export const INITIAL_SLA_CONFIG = {
  firstResponseTime: { value: 15, unit: 'minutes' },
  resolutionTime: { value: 4, unit: 'hours' },
  delayAlerts: [
    { id: 'warning', percent: 80, label: 'Alerta de Atenção', enabled: true, color: 'amber' },
    { id: 'critical', percent: 100, label: 'Alerta Crítico', enabled: true, color: 'rose' },
  ],
};
